/* eslint-disable react/jsx-props-no-spreading */
import { useSelector } from "react-redux";

import withBrand from "@/components/with-brand";
import { CurrentPolicyPoliciesAreaSchema } from "@/schema/renewal-page/current-policy-page.schema";
import { RootState } from "@/store/root-reducer";
import { BrandKey } from "@/types/common-types";
import isCruiseImpact from "@/utils/check-cruise-impact-base-on-brand.utils";
import { getCoverLevelInfo } from "@/utils/get-cover-level-info";

import { CurrentPolicyCoverBottom } from "./current-policy-cover-bottom/current-policy-cover-bottom";
import { CurrentPolicyCoverTop } from "./current-policy-cover-top/current-policy-cover-top";

type CurrentPolicyCoverProps = CurrentPolicyPoliciesAreaSchema & {
  brand?: BrandKey;
};

function CurrentPolicyCoverCard({
  coverLevelBenefits,
  coverBannerText,
  ...props
}: Readonly<CurrentPolicyCoverProps>) {
  const { attributes } = useSelector((state: RootState) => state.quote);
  const { tripDetails } = attributes;
  const { coverTop, bottomContent } = getCoverLevelInfo(
    coverLevelBenefits,
    tripDetails?.policyPackage ?? "",
    tripDetails?.goingOnCruise && isCruiseImpact
  );

  return (
    <>
      <CurrentPolicyCoverTop
        content={{ ...coverTop, coverBannerText }}
        currentPolicy={tripDetails?.policyPackage ?? ""}
      />
      <CurrentPolicyCoverBottom
        benefitsCopy={bottomContent.benefitsCopy}
        currentPolicy={tripDetails?.policyPackage ?? ""}
        {...props}
      />
    </>
  );
}

export default withBrand(CurrentPolicyCoverCard);
